<template>
  <div v-if="customer" class="payment-methods">
    <div
      v-for="method in paymentMethods"
      :key="method.id"
      class="d-flex justify-content-between align-items-center payment-method"
      :class="{ active: method.id === selectedID }"
      @click="selectPaymentMethod(null)"
    >
      <div v-if="method.payment_type === 'card'">
        <div class="d-flex align-items-center">
          <component :is="cardImages[method.brand]" class="mr-2" />
          <span>
            <b>{{ method.brand }}</b> ending in
            <b>{{ method.last4 }}</b> expiring on
            <b>{{ method.exp_month }}/{{ method.exp_year }}</b>
          </span>
          <span v-if="method.expired" class="ml-1"><b>(Expired)</b></span>
        </div>
        <div>
          <!-- Support existing payment methods without billing address info -->
          <div v-if="savedPaymentBillingAddress?.cityStateZip">
            <div><b>Billing Address:</b></div>
            <div>{{ savedPaymentBillingAddress.name }}</div>
            <div>{{ savedPaymentBillingAddress.street }}</div>
            <div>{{ savedPaymentBillingAddress.cityStateZip }}</div>
          </div>
          <div v-else>
            <div>{{ fullName }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="method.payment_type === 'ach'"
        class="d-flex align-items-center"
      >
        <i class="fas fa-university mr-2"></i>
        <span>
          {{ capitalize(method.ach_account_type) }} account ending in
          <b>{{ method.last4 }}</b>
        </span>
      </div>
      <i
        v-if="hasDelete"
        class="fas fa-trash-alt link"
        @click="handleDeletePaymentMethod(method)"
      />
    </div>
    <div v-if="!paymentMethods.length" class="no-results-message p-0">
      No payment method on file
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import amexSrc from "@/images/amex.svg?component";
import discoverSrc from "@/images/discover.svg?component";
import mastercardSrc from "@/images/mastercard.svg?component";
import visaSrc from "@/images/visa.svg?component";
import usePaymentMethods from "./usePaymentMethods";

export default {
  name: "CustomerPaymentMethods",
  props: {
    customer: {
      type: Object,
      default: null
    },
    selectedID: {
      type: Number,
      default: null
    },
    selectPaymentMethod: {
      type: Function,
      default: () => {}
    },
    onPaymentMethodRemoved: {
      type: Function
    }
  },
  emits: ["payment-method-removed"],
  setup() {
    const { savedPaymentBillingAddress, deletePaymentMethod, fullName } =
      usePaymentMethods();
    return {
      fullName,
      savedPaymentBillingAddress,
      deletePaymentMethod
    };
  },
  data() {
    return {
      cardImages: {
        Visa: visaSrc,
        MasterCard: mastercardSrc,
        Discover: discoverSrc,
        "American Express": amexSrc
      },
      open: false,
      deleteId: null
    };
  },
  computed: {
    hasDelete() {
      return this.$props.onPaymentMethodRemoved;
    },
    paymentMethods() {
      return this.customer.payment_method ? [this.customer.payment_method] : [];
    }
  },
  methods: {
    ...mapActions(["confirmDelete"]),
    handleDeletePaymentMethod(paymentMethod) {
      this.confirmDelete({
        message:
          "This action cannot be undone. Are you sure you wish to continue?",
        title: "Confirm Remove Payment Method"
      }).then(() => {
        this.deletePaymentMethod(paymentMethod.payment_method_delete_url).then(
          () => {
            // for parent component
            this.$emit("payment-method-removed");

            // for any other components
            EventBus.$emit("payment-method-removed");
          }
        );
      });
    }
  }
};
</script>
